<template>
    <div>
        <div class="form-group">
            <label>Target Url</label>
            <input type="text" class="form-control" v-model="data.targetUrl">
        </div>
        <div class="form-group">
            <el-checkbox v-model="data.sendDriverType">Send Route Type</el-checkbox>
        </div>
        <div class="form-group">
            <el-checkbox v-model="data.sendOOInfo">Send OO Info</el-checkbox>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>
